export const getSensorOverviewTour = () => [
  {
    target: 'body',
    title: 'Sensorer',
    content:
      'Sensorer er stedet, hvor du får et overblik over de ReMoni sensorer, der har haft forbindelse til de gateways, som er registreret på kontoen. Sensor-tabellen opdateres automatisk ud fra forbindelserne til dine registrerede gateways.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: 'body',
    title: 'Automatisk registrering af sensorer',
    content:
      'Når en sensor har haft forbindelse til en registreret gateway, bliver den vist i oversigten. Sensoren bliver stående i tabellen, selvom den ikke længere er online. Hvis du forventer at se sensorer, men tabellen er tom, skal du først tjekke Gateways-tabben. Her kan du registrere en gateway eller kontrollere, om gatewayens forbindelsesstatus er korrekt.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="datagrid-toolbar"]',
    spotlightTarget: '[data-tour="sensor-overview-grid"]',
    title: 'Oversigt over dine sensorer',
    content:
      'I sensor-tabellen kan du se de ReMoni sensorer, der har haft forbindelse til dine registrerede gateways. Tabellen viser blandt andet sensorens status, unikke Sensor ID, sensortype og hvilke units sensoren er tilkoblet.',
    placement: 'auto',
  },
  {
    target: '[data-field="actions"]',
    title: 'Administrer en sensor',
    content:
      'I den sidste kolonne på hver række kan du se eller slette en sensor. Hver række repræsenterer en ReMoni sensor, der har haft forbindelse til en registreret gateway.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="datagrid-search-trigger"]',
    title: 'Søg efter sensorer',
    content:
      'Brug søgefeltet til hurtigt at finde en bestemt sensor. Du kan for eksempel søge på Sensor ID, sensortype eller andre oplysninger, der vises i tabellen.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="datagrid-columns-trigger"]',
    title: 'Vælg kolonner',
    content:
      'Du kan selv vælge, hvilke kolonner der skal vises i tabellen. Det gør det nemmere at tilpasse overblikket, så du kun ser de oplysninger, der er relevante for dig.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="datagrid-filters-trigger"]',
    title: 'Filtrer sensorer',
    content:
      'Brug filtrering til at indsnævre visningen i tabellen. Det kan for eksempel være nyttigt, hvis du kun vil se sensorer med en bestemt status, type eller unit-tilkobling.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="datagrid-export-trigger"]',
    title: 'Eksporter sensor-data',
    content:
      'Du kan eksportere sensor-tabellen til Excel eller CSV. Det er nyttigt, hvis du vil arbejde videre med data uden for ReCalc eller dele oversigten med andre.',
    placement: 'bottom',
  },
];
